export default "__VITE_ASSET__iJPD14a___"